var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mobile-menu" }, [
    _c("div", {
      staticClass: "header__burger",
      class: _vm.button,
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggle($event)
        }
      }
    }),
    _c("div", { staticClass: "menu", class: _vm.drawer }, [
      _c("div", { staticClass: "menu__overlay", class: _vm.overlay }),
      _c(
        "div",
        { staticClass: "menu__sidebar", class: _vm.sidebar },
        [
          _vm._t("navigations"),
          _vm.auth
            ? _c(
                "div",
                { staticClass: "menu__template" },
                [
                  _c(
                    "text-bemto",
                    {
                      staticClass: "c c--hover_common",
                      attrs: {
                        fw: "medium",
                        lh: "initial",
                        fs: ["1xs"],
                        color: "grey4",
                        tag: "p"
                      },
                      on: { event: _vm.postLogoutCabinetAPI }
                    },
                    [_vm._v("Logout")]
                  )
                ],
                1
              )
            : _vm._e()
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a98d49f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a98d49f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/Modules/MenuModule.vue
// module id = 928
// module chunks = 0